/* Lemieux — Fabric Selector behavior.
   Reads #fs-fabrics (library+avail), #fs-options (order+inline), #fs-variants (variant map by title).
   Fabric in drawer (auto-applies on "View Fabric"); Size/Leg inline. Writes variant id to product form.
   #fs-inquire (optional): inquiry-only fabrics (e.g. Métaphores) shown under their own tab with an
   "Inquire for Price" button that opens the custom-request modal — never changes the cart variant. */
(function () {
  var root = document.querySelector('.fs'); if (!root) return;
  var FABRICS = JSON.parse(qs('#fs-fabrics') || '[]');
  var OPT = JSON.parse(qs('#fs-options') || '{"order":[],"inline":[]}');
  var VMAP = JSON.parse(qs('#fs-variants') || '{}');
  var INQ = []; try { INQ = JSON.parse(qs('#fs-inquire') || '[]') || []; } catch(e){ INQ = []; }
  var INQ_LABEL = root.dataset.inqLabel || 'Métaphores', INQ_BTN = root.dataset.inqBtn || 'Inquire for Price';
  var INQ_MSG = 'Please send pricing and lead time for this fabric on this piece.';
  var inqGroups = []; INQ.forEach(function(f){ if(inqGroups.indexOf(f.group)<0) inqGroups.push(f.group); });
  var inqCur = null;
  function qs(id){var e=document.querySelector(id);return e?e.textContent:'';}
  var drawer = document.querySelector('[data-fs-drawer]'), scrim = document.querySelector('[data-fs-scrim]');
  var body = drawer.querySelector('[data-fs-body]'), tabsEl = drawer.querySelector('[data-fs-tabs]'), searchEl = drawer.querySelector('[data-fs-search]');
  /* Portal the fixed overlays to <body> so they escape any ancestor stacking context (sticky product columns) and sit above the product gallery. */
  [scrim, drawer].forEach(function(el){ if(el && el.parentNode !== document.body) document.body.appendChild(el); });
  var SWATCH_CENTS = parseInt(root.dataset.swatchCents,10) || 300;
  var money = function(c){ try { return Shopify.formatMoney(c, window.moneyFormat || '${{amount}}'); } catch(e){ return '$' + Math.round(c/100).toLocaleString(); } };

  var types = []; FABRICS.forEach(function(f){ if(types.indexOf(f.type)<0) types.push(f.type); });
  var order = OPT.order || [];
  var inlineDefs = OPT.inline || [];
  var inlineSel = {}; inlineDefs.forEach(function(o){ inlineSel[o.name] = o.values[0] && o.values[0].value; });

  var sel = FABRICS.filter(function(f){return f.avail;})[0] || FABRICS[0];
  var pending = sel, activeTab = 'All', samples = {}, built = false;

  function variantKey(fabricName){
    return order.map(function(n){ return n==='Fabric' ? fabricName : inlineSel[n]; }).join(' / ');
  }
  function variantFor(fabricName){ return VMAP[variantKey(fabricName)]; }
  function priceFor(f){ if(!f.avail) return 'By custom order'; var v=variantFor(f.name); return v?money(v.price):''; }
  var availCount = FABRICS.filter(function(f){return f.avail;}).length;

  /* URL <-> selection sync. Outgoing: mirror the chosen variant into ?variant= (like the native
     picker) so the address bar is shareable. Incoming: if the page loads with ?variant=<id>,
     preselect the matching fabric + inline options so a shared link reopens on that combo. */
  var urlApplied = false;
  function syncUrl(id){
    try{
      if(!id || !window.history || !history.replaceState || typeof URL!=='function') return;
      var u=new URL(window.location.href);
      if(u.searchParams.get('variant')===String(id)) return;
      u.searchParams.set('variant', id);
      history.replaceState(history.state, '', u.toString());
    }catch(e){}
  }
  function preselectFromUrl(){
    try{
      var m=(window.location.search||'').match(/[?&]variant=(\d+)/);
      if(!m) return false;
      var vid=m[1], key=null;
      for(var k in VMAP){ if(VMAP[k] && String(VMAP[k].id)===vid){ key=k; break; } }
      if(!key) return false;
      var parts=key.split(' / ');
      if(parts.length!==order.length) return false;
      var fabName=null;
      order.forEach(function(n,i){ if(n==='Fabric') fabName=parts[i]; else if(inlineSel.hasOwnProperty(n)) inlineSel[n]=parts[i]; });
      if(fabName){ var f=FABRICS.filter(function(x){return x.name===fabName;})[0]; if(f){ sel=f; pending=f; } else { return false; } }
      inlineDefs.forEach(function(o){
        inlineWrap.querySelectorAll('[data-opt="'+cssAttr(o.name)+'"]').forEach(function(x){
          x.setAttribute('aria-selected', x.dataset.val===inlineSel[o.name]);
        });
      });
      return true;
    }catch(e){ return false; }
  }

  var _pid;
  function themePid(){
    if(_pid!==undefined) return _pid;
    _pid = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) || null;
    if(!_pid){ var b=document.querySelector('a.block_media[data-product]'); _pid = b ? parseInt(b.getAttribute('data-product'),10) : null; }
    return _pid;
  }
  function updateBuy(){
    var v = variantFor(sel.name);
    setChip(root.querySelector('#fs-selchip'), sel);
    root.querySelector('#fs-selname').textContent = sel.name;
    root.querySelector('#fs-seltype').textContent = sel.type + ' · ' + priceFor(sel);
    root.querySelector('#fs-fabcount').textContent = 'Available in ' + availCount;
    var fromBits = inlineDefs.map(function(o){ return inlineSel[o.name]; });
    root.querySelector('#fs-from').textContent = fromBits.join(' · ');
    if (v){
      root.querySelector('#fs-price').textContent = money(v.price);
      root.querySelector('#fs-variant-id').value = v.id;
      syncUrl(v.id);
      var main = document.querySelector('[data-fs-main-image] img, .product__media img, .product-media img');
      if (main && v.img) main.src = v.img;
      document.dispatchEvent(new CustomEvent('variant:change', { detail:{ id:v.id }}));
      /* This theme's Alpine gallery + cart listen for window events `media-select`
         ({product, position}) and `variant-changed` ({product_id, variant_id}). Fire them so the
         main product photo follows the selected fabric and the cart uses the right variant. */
      var pid = themePid();
      if (pid){
        window.dispatchEvent(new CustomEvent('variant-changed', { detail:{ product_id: pid, variant_id: v.id } }));
        if (v.img){
          var fn = (''+v.img).split('/').pop().split('?')[0];
          var slide = [].slice.call(document.querySelectorAll('a.block_media[data-product="'+pid+'"]'))
            .filter(function(a){ return (a.getAttribute('href')||'').indexOf(fn) >= 0; })[0];
          if (slide){ window.dispatchEvent(new CustomEvent('media-select', { detail:{ product: pid, position: parseInt(slide.getAttribute('data-position'),10) } })); }
        }
      }
    }
    root.querySelectorAll('.fs__fchip').forEach(function(c){ c.setAttribute('aria-selected', c.dataset.n === sel.name); });
  }
  function setChip(el, f){ if(!el) return; if(f.img){ el.style.backgroundImage='url('+f.img+')'; el.style.backgroundSize='cover'; } else { el.style.background=f.hex; } }

  /* featured */
  var feat = root.querySelector('#fs-featured');
  FABRICS.filter(function(f){return f.avail;}).slice(0, parseInt(root.dataset.featured,10)||6).forEach(function(f){
    var b=document.createElement('button'); b.type='button'; b.className='fs__fchip'; b.dataset.n=f.name; setChip(b,f);
    b.title=f.name+' — '+f.type; b.onclick=function(){ sel=f; pending=f; updateBuy(); }; feat.appendChild(b);
  });

  /* inline Size / Leg selectors */
  var inlineWrap = root.querySelector('#fs-inline');
  inlineDefs.forEach(function(o){
    var field=document.createElement('div'); field.className='fs__field';
    var isLeg = /leg|finish|color/i.test(o.name);
    var label='<div class="fs__label"><b>'+o.name+'</b><span data-fs-optname="'+o.name+'"></span></div>';
    if (isLeg){
      var row='<div class="fs__bases">'+o.values.map(function(v){
        var sw = v.img ? 'background-image:url('+v.img+');background-size:cover' : 'background:'+(v.swatch||'#ccc');
        return '<button type="button" class="fs__base" data-opt="'+o.name+'" data-val="'+esc(v.value)+'"><span class="fs__bswatch" style="'+sw+'"></span><small>'+v.value+'</small></button>';
      }).join('')+'</div>';
      field.innerHTML=label+row;
    } else {
      var seg='<div class="fs__seg">'+o.values.map(function(v){
        return '<button type="button" class="fs__segbtn" data-opt="'+o.name+'" data-val="'+esc(v.value)+'">'+v.value+'</button>';
      }).join('')+'</div>';
      field.innerHTML=label+seg;
    }
    inlineWrap.appendChild(field);
  });
  inlineWrap.querySelectorAll('[data-opt]').forEach(function(btn){
    btn.onclick=function(){ var n=btn.dataset.opt; inlineSel[n]=btn.dataset.val;
      inlineWrap.querySelectorAll('[data-opt="'+n+'"]').forEach(function(x){x.setAttribute('aria-selected','false');}); btn.setAttribute('aria-selected','true'); updateBuy(); };
  });
  function markInlineDefaults(){ inlineDefs.forEach(function(o){ var b=inlineWrap.querySelector('[data-opt="'+cssesc(o.name)+'"]'); if(b) b.setAttribute('aria-selected','true'); root.querySelector('[data-fs-optname="'+cssAttr(o.name)+'"]'); }); }
  inlineWrap.querySelectorAll('[data-opt]').forEach(function(b,i){ /* set first of each as selected */ });
  inlineDefs.forEach(function(o){ var first=inlineWrap.querySelector('[data-opt="'+cssAttr(o.name)+'"]'); if(first) first.setAttribute('aria-selected','true'); });

  /* drawer */
  function open(){ scrim.classList.add('open'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); pending=sel; buildTabs(); render(); footer(); }
  function close(){ scrim.classList.remove('open'); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); }
  root.querySelectorAll('[data-fs-open]').forEach(function(b){ b.onclick=open; });
  drawer.querySelector('[data-fs-close]').onclick=close; scrim.onclick=close; searchEl.oninput=render;
  drawer.querySelector('[data-fs-use]').onclick=function(){ if(!pending.avail){ openCustom(pending); return; } close(); };

  function buildTabs(){ tabsEl.innerHTML='';
    ['All'].concat(types).concat(INQ.length ? [INQ_LABEL] : []).forEach(function(t){ var b=document.createElement('button'); b.type='button'; b.className='fs-tab'+(t===INQ_LABEL&&INQ.length?' fs-tab-inq':''); b.textContent=t; b.setAttribute('aria-selected',t===activeTab); b.onclick=function(){ activeTab=t; buildTabs(); render(); }; tabsEl.appendChild(b); });
  }
  var io = ('IntersectionObserver'in window) ? new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ var el=e.target; setTimeout(function(){ el.classList.remove('shim'); if(el.dataset.img){ el.style.backgroundImage='url('+el.dataset.img+')'; el.style.backgroundSize='cover'; } else el.style.background=el.dataset.hex; },130); io.unobserve(el); } }); }, { root: body, rootMargin:'120px' }) : null;

  function render(){
    var q=(searchEl.value||'').toLowerCase().trim(); body.innerHTML='';
    var isInqTab = INQ.length && activeTab===INQ_LABEL;
    var groups = activeTab==='All'? types : (isInqTab ? [] : [activeTab]); var any=false;
    groups.forEach(function(ty){
      var items = FABRICS.filter(function(f){ return f.avail && f.type===ty && (!q || f.name.toLowerCase().indexOf(q)>=0 || f.type.toLowerCase().indexOf(q)>=0); });
      if(!items.length) return; any=true;
      var av = items.filter(function(f){return f.avail;})[0];
      var h=document.createElement('div'); h.className='fs-grouphead';
      h.innerHTML = ty + ' <span>'+items.length+' color'+(items.length>1?'s':'')+(av?' · from '+priceFor(av):' · custom order')+'</span>';
      body.appendChild(h);
      var g=document.createElement('div'); g.className='fs-grid';
      items.forEach(function(f){
        var el=document.createElement('div'); el.className='fs-sw'; el._n=f.name; el.setAttribute('aria-selected', f.name===pending.name);
        el.innerHTML='<div class="fs-big shim"><span class="fs-flag">✓ Selected</span>'+(f.avail?'':'<span class="fs-cflag">CUSTOM</span>')+'</div>'+
          '<div class="fs-info"><div class="fs-nm">'+f.name+'</div><div class="fs-pr">'+(f.avail?priceFor(f):'By custom order')+'</div>'+
          '<div class="fs-acts">'+(f.avail?'<button type="button" class="fs-pick">'+(f.name===pending.name?'✓ Selected':'View Fabric')+'</button>':'<button type="button" class="fs-pick req">Request this fabric</button>')+
          (f.sampleVariantId && f.swatchAvail!==false?'<button type="button" class="fs-samp'+(samples[f.name]?' on':'')+'">'+(samples[f.name]?'✓ Swatch added':'＋ Add swatch')+'</button>':'')+'</div></div>';
        var big=el.querySelector('.fs-big'); big.dataset.hex=f.hex; big.dataset.img=f.img||'';
        var pk=el.querySelector('.fs-pick');
        if(f.avail){ pk.onclick=function(){choose(f);}; big.onclick=function(){choose(f);}; } else { pk.onclick=function(){openCustom(f);}; big.onclick=function(){openCustom(f);}; }
        var sb=el.querySelector('.fs-samp'); if(sb) sb.onclick=function(e){ e.stopPropagation(); toggleSample(f, sb); };
        g.appendChild(el); if(io) io.observe(big); else { big.classList.remove('shim'); if(f.img){big.style.backgroundImage='url('+f.img+')';big.style.backgroundSize='cover';} else big.style.background=f.hex; }
      });
      body.appendChild(g);
    });
    if(INQ.length && (activeTab==='All' || isInqTab)){ if(renderInquire(q)) any=true; }
    if(!any) body.innerHTML='<p class="fs-empty">No fabrics match “'+q+'”.</p>';
  }
  /* Inquiry-only fabrics (Métaphores): one group per pattern, "Inquire for Price" opens the request modal. */
  function renderInquire(q){
    var any=false;
    inqGroups.forEach(function(gn){
      var items = INQ.filter(function(f){ return f.group===gn && (!q || f.name.toLowerCase().indexOf(q)>=0 || gn.toLowerCase().indexOf(q)>=0 || INQ_LABEL.toLowerCase().indexOf(q)>=0 || (f.sku||'').toLowerCase().indexOf(q)>=0); });
      if(!items.length) return; any=true;
      var h=document.createElement('div'); h.className='fs-grouphead fs-inqhead';
      h.innerHTML = INQ_LABEL+' · '+gn+' <span>'+items.length+' color'+(items.length>1?'s':'')+' · pricing on request</span>';
      body.appendChild(h);
      var g=document.createElement('div'); g.className='fs-grid';
      items.forEach(function(f){
        var el=document.createElement('div'); el.className='fs-sw fs-inq';
        el.innerHTML='<div class="fs-big shim"><span class="fs-iflag">'+INQ_LABEL+'</span></div>'+
          '<div class="fs-info"><div class="fs-nm">'+f.name+'</div><div class="fs-pr">Pricing on request</div>'+
          '<div class="fs-acts"><button type="button" class="fs-pick fs-inqbtn">'+INQ_BTN+'</button></div></div>';
        var big=el.querySelector('.fs-big'); big.dataset.hex='#d8d4cd'; big.dataset.img=f.img||'';
        var go=function(){ openInquire(f); };
        el.querySelector('.fs-pick').onclick=go; big.onclick=go;
        g.appendChild(el); if(io) io.observe(big); else { big.classList.remove('shim'); if(f.img){big.style.backgroundImage='url('+f.img+')';big.style.backgroundSize='cover';} else big.style.background='#d8d4cd'; }
      });
      body.appendChild(g);
    });
    if(any){ var lg=document.createElement('p'); lg.className='fs-inqlegal'; lg.style.cssText='font-size:.72rem;color:var(--fs-muted);margin:22px 0 4px;line-height:1.4';
      lg.textContent=root.dataset.inqLegal || 'Métaphores™ is a trademark of Hermès International.'; body.appendChild(lg); }
    return any;
  }
  function choose(f){ sel=f; pending=f; updateBuy();
    body.querySelectorAll('.fs-sw').forEach(function(el){ if(el.classList.contains('fs-inq')) return; var s=el._n===f.name; el.setAttribute('aria-selected',s); var p=el.querySelector('.fs-pick'); if(p&&!p.classList.contains('req')) p.textContent=s?'✓ Selected':'View Fabric'; });
    footer();
  }
  function toggleSample(f, btn){ if(samples[f.name]){ delete samples[f.name]; btn.classList.remove('on'); btn.textContent='＋ Add swatch'; } else { samples[f.name]=f.sampleVariantId; btn.classList.add('on'); btn.textContent='✓ Swatch added'; } footer(); }
  function footer(){ setChip(drawer.querySelector('[data-fs-pchip]'), pending);
    drawer.querySelector('[data-fs-pname]').textContent=pending.name; drawer.querySelector('[data-fs-ptype]').textContent=pending.type+' · '+priceFor(pending);
    drawer.querySelector('[data-fs-use]').textContent = pending.avail ? 'Done' : 'Request this fabric';
    var keys=Object.keys(samples), row=drawer.querySelector('[data-fs-samples]');
    row.innerHTML = keys.length ? '<span>🧵 '+keys.length+' swatch'+(keys.length>1?'es':'')+' · '+money(keys.length*SWATCH_CENTS)+'</span><button type="button" class="fs-order">Add swatches to cart →</button>' : '';
    var ob=row.querySelector('.fs-order'); if(ob) ob.onclick=orderSamples;
  }
  function orderSamples(){ var items=Object.keys(samples).map(function(k){return {id:samples[k],quantity:1};}).filter(function(i){return i.id;});
    if(!items.length){ alert('These fabrics have no sample SKU linked yet.'); return; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}).then(function(r){return r.json();}).then(function(){ document.dispatchEvent(new CustomEvent('cart:refresh')); }).catch(function(){ alert('Could not add swatches.'); });
  }

  /* custom form */
  var KLAVIYO_KEY='Y8e7BH';
  var modal=document.querySelector('[data-fs-modal]');
  if(modal && modal.parentNode !== document.body) document.body.appendChild(modal);
  function productTitle(){ return root.dataset.productTitle || (document.title.split('–')[0] || '').trim() || 'sofa'; }
  function selectionLine(f){ var base=(f||sel).name+' ('+(f||sel).type+') on the '+ (document.querySelector('.fs__price')?document.title.split('–')[0].trim():'sofa'); var bits=inlineDefs.map(function(o){return inlineSel[o.name];}); return base + (bits.length?' — '+bits.join(' / '):''); }
  /* Switch the shared request modal between the standard custom-quote copy and the inquiry copy. */
  var modalDefaults=null;
  function setModalMode(inq){
    if(!modal) return;
    var h=modal.querySelector('.fs-mh h2'), bl=modal.querySelector('.fs-blurb'), rq=modal.querySelector('[name="Requesting"]'), bd=modal.querySelector('[name="body"]');
    if(!modalDefaults) modalDefaults={ h:h?h.textContent:'', bl:bl?bl.innerHTML:'', rq:rq?rq.value:'Custom Sofa' };
    if(inq){
      if(h) h.textContent='Request '+INQ_LABEL+' Pricing';
      if(bl) bl.innerHTML=root.dataset.inqBlurb || ('Our team will follow up with pricing and lead time for this '+INQ_LABEL+' fabric on this piece.');
      if(rq) rq.value=INQ_LABEL+' fabric pricing';
      if(bd && !bd.value) bd.value=INQ_MSG;
    } else {
      inqCur=null;
      if(h) h.textContent=modalDefaults.h; if(bl) bl.innerHTML=modalDefaults.bl; if(rq) rq.value=modalDefaults.rq;
      if(bd && bd.value===INQ_MSG) bd.value='';
    }
  }
  function openCustom(f){ if(modal){ setModalMode(false); var ctx=modal.querySelector('[data-fs-ctx]'); var line=selectionLine(f&&f.name?f:null); if(ctx) ctx.innerHTML=(f&&!f.avail?'<b>Requesting custom fabric:</b><br>':'<b>Requesting about:</b><br>')+line; var hid=modal.querySelector('[data-fs-ctx-field]'); if(hid) hid.value=line; modal.classList.add('open'); } }
  function openInquire(f){
    if(!modal) return;
    setModalMode(true); inqCur=f;
    var bits=inlineDefs.map(function(o){return inlineSel[o.name];});
    var line=INQ_LABEL+' '+f.group+' – '+f.name+(f.sku?' ('+f.sku+')':'')+' on the '+productTitle()+(bits.length?' — '+bits.join(' / '):'');
    var ctx=modal.querySelector('[data-fs-ctx]'); if(ctx) ctx.innerHTML='<b>Requesting pricing for:</b><br>'+line;
    var hid=modal.querySelector('[data-fs-ctx-field]'); if(hid) hid.value=line;
    modal.classList.add('open');
  }
  if(modal){ root.querySelectorAll('[data-fs-custom]').forEach(function(b){ b.onclick=function(){ openCustom(); }; });
    modal.querySelector('[data-fs-mclose]').onclick=function(){ modal.classList.remove('open'); };
    modal.addEventListener('click',function(e){ if(e.target===modal) modal.classList.remove('open'); });
    /* Record the request in Klaviyo as a "Requested Custom Quote" event on the customer's profile.
       Preferred path is the store's already-initialized onsite object (window.klaviyo .identify/.track)
       — no captcha, no CORS/preflight, same pipeline the store's other events use. Falls back to the
       legacy _learnq queue, then to the Client Events API (public key). No Shopify /contact, no reload. */
    var METRIC = 'Requested Custom Quote';
    var csubmit = modal.querySelector('[data-fs-submit]');
    var cform = modal.querySelector('[data-fs-cform]');
    function cval(n){ var el=cform&&cform.querySelector('[name="'+n+'"]'); return el?(''+el.value).trim():''; }
    function cerr(m){ var e=cform&&cform.querySelector('[data-fs-ferr]'); if(e){ e.textContent=m||''; e.hidden=!m; } }
    if(csubmit && cform){
      csubmit.addEventListener('click', function(){
        cerr('');
        var name=cval('name'), email=cval('email'), body=cval('body');
        function focus(n){ var el=cform.querySelector('[name="'+n+'"]'); if(el) el.focus(); }
        if(!name){ cerr('Please enter your name.'); focus('name'); return; }
        if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ cerr('Please enter a valid email address.'); focus('email'); return; }
        if(!body){ cerr('Please tell us what you’re looking for.'); focus('body'); return; }
        var phone=cval('Phone');
        var props={ Product:cval('Product'), Requesting:cval('Requesting')||'Custom Sofa', Phone:phone, Message:body, Source:'Fabric drawer — custom request', URL:location.href };
        if(inqCur){ props.Fabric=INQ_LABEL+' '+inqCur.group+' – '+inqCur.name; props.SKU=inqCur.sku||''; props.Source='Fabric drawer — '+INQ_LABEL+' inquiry'; }
        var orig=csubmit.textContent; csubmit.disabled=true; csubmit.textContent='Sending…';
        function fail(){ csubmit.disabled=false; csubmit.textContent=orig; cerr('Sorry — we couldn’t send that. Please try again, or email assist@lemieuxetcie.com.'); }
        function done(){
          var box=modal.querySelector('.fs-mbox');
          if(box){ box.innerHTML='<div class="fs-mh"><h2>Request sent</h2><button type="button" class="fs-mx" data-fs-mclose aria-label="Close">×</button></div><div class="fs-thanks"><div class="ok">✓</div><p>Thank you — our team will follow up with you shortly.</p></div>';
            var x=box.querySelector('[data-fs-mclose]'); if(x) x.onclick=function(){ modal.classList.remove('open'); }; }
        }
        /* 1) Onsite Klaviyo object (present on this store, already carries the company id) */
        var k = window.klaviyo;
        if (k && typeof k.identify==='function' && typeof k.track==='function'){
          try { k.identify({ email:email, first_name:name }); k.track(METRIC, props); done(); return; } catch(e){}
        }
        /* 2) Legacy onsite queue */
        var lq = window.klaviyo || window._learnq;
        if (lq && typeof lq.push==='function'){
          try { lq.push(['identify', { '$email':email, '$first_name':name }]); lq.push(['track', METRIC, props]); done(); return; } catch(e){}
        }
        /* 3) Client Events API fallback */
        if(typeof fetch!=='function'){ fail(); return; }
        fetch('https://a.klaviyo.com/client/events/?company_id='+KLAVIYO_KEY, {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'revision':'2024-10-15' },
          body:JSON.stringify({ data:{ type:'event', attributes:{
            properties:props,
            metric:{ data:{ type:'metric', attributes:{ name:METRIC } } },
            profile:{ data:{ type:'profile', attributes:{ email:email, first_name:name, properties:{ Phone:phone } } } }
          }}})
        }).then(function(r){ if(r.status===202||r.ok){ done(); } else { fail(); } }).catch(function(){ fail(); });
      });
    }
  }

  function esc(s){ return (''+s).replace(/"/g,'&quot;'); }
  function cssAttr(s){ return (''+s).replace(/"/g,'\\"'); }
  function cssesc(s){ return cssAttr(s); }

  /* Hydrate the full variant map for high-variant products. Liquid's #fs-variants and /products/x.js
     both cap at 250 variants, so on pieces like the Fontaine (350) the newest fabrics fall outside
     the map and can't resolve to a variant (no image/price/id). Fetch the uncapped ?view=fsvariants
     feed across all pages and merge any missing variants in, then refresh. Only fills gaps — existing
     entries (with their images) are left untouched. */
  (function hydrateVariants(){
    if(typeof fetch!=='function') return;
    var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
    if(!handle) return;
    function getPage(p){
      return fetch('/products/'+handle+'?view=fsvariants&page='+p,{headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){ return r.ok ? r.json() : null; });
    }
    function apply(list){ (list||[]).forEach(function(v){ var k=(v.opts||[]).join(' / '); if(k && !VMAP[k]) VMAP[k]={id:v.id,price:v.price,img:v.img||''}; }); }
    getPage(1).then(function(d){
      if(!d) return;
      apply(d.variants);
      var pages=d.pages||1, rest=[];
      for(var p=2;p<=pages;p++) rest.push(getPage(p));
      return Promise.all(rest).then(function(ds){ ds.forEach(function(dd){ if(dd) apply(dd.variants); }); });
    }).then(function(){
      try{ if(!urlApplied) urlApplied=preselectFromUrl(); updateBuy(); if(drawer && drawer.classList.contains('open')) render(); }catch(e){}
    }).catch(function(){});
  })();

  urlApplied = preselectFromUrl();
  updateBuy();
})();
